import { api } from './api'

export type ConsumableType = 'FUEL' | 'OIL' | 'NITROUS' | 'TYRE';

export interface ConsumableInfo {

    priceList: {
        FUEL: number;
        OIL: number;
        NITROUS: number;
        TYRE: number;
    }

    remaining: {
        FUEL: number;
        OIL: number;
        NITROUS: number;
        TYRE: number;
    }
    
}

export class ConsumableService {

    static async fetchConsumableInfo(vehicleId: number): Promise<ConsumableInfo> {
        const response = await api.get(`/vehicle/consumables?vehicleId=${vehicleId}`);
        return response.data as ConsumableInfo;
    }

    static async buyConsumable(vehicleId: number, consumable: ConsumableType, amount: number): Promise<void> {
        await api.post(`/vehicle/consumables/buy`, { vehicleId, consumable, amount });
    }

} 